"use client";

import React from "react";
import { CUSTOM_ATTRIBUTE_NAME } from "./constants";

import { handlers as defaultHandlers } from "./handlers";

/*

This will only work with elements that are in the initial DOM,
but could easily be extended to capture elements added to the page later
if we should ever require it

*/

type handler = (element: HTMLElement) => void;

type Props = {
  handlers?: Record<string, handler>;
};

export function IntersectionDelegate({
  handlers = defaultHandlers
}: Props): null {
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const value = entry.target.getAttribute(CUSTOM_ATTRIBUTE_NAME);

          if (!value) return;

          const names = value.split(",");

          names.forEach((name) => {
            handlers[name]?.(entry.target as HTMLElement);
          });

          observer.unobserve(entry.target);
        });
      },
      {
        threshold: [0.5]
      }
    );

    document.body
      .querySelectorAll(`[${CUSTOM_ATTRIBUTE_NAME}]`)
      .forEach((el) => observer.observe(el));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
